'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'
import { ArrowRight, Check } from 'lucide-react'
import { useTranslations } from 'next-intl'
import '../../sass/landing/FinalCta.scss'

const FinalCta = () => {
  const t = useTranslations('LandingV2.finalCta')

  return (
    <section className='final-cta'>
      <div className='final-cta__container'>
        <motion.div
          className='final-cta__card'
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className='final-cta__bg' aria-hidden='true'>
            <div className='final-cta__grid-bg' />
            <div className='final-cta__orb final-cta__orb--1' />
            <div className='final-cta__orb final-cta__orb--2' />
          </div>

          <div className='final-cta__content'>
            <span className='final-cta__chip'>{t('chip')}</span>
            <h2 className='final-cta__title'>{t('heading')}</h2>
            <p className='final-cta__subtitle'>{t('subtitle')}</p>

            <div className='final-cta__ctas'>
              <Link href='/login/signup' className='final-cta__btn final-cta__btn--primary'>
                {t('primaryCta')} <ArrowRight size={16} />
              </Link>
              <a href='mailto:info@barmanager.app' className='final-cta__btn final-cta__btn--ghost'>
                {t('secondaryCta')}
              </a>
            </div>

            <div className='final-cta__meta'>
              <span><Check size={12} /> {t('meta1')}</span>
              <span><Check size={12} /> {t('meta2')}</span>
              <span><Check size={12} /> {t('meta3')}</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default FinalCta
